export const paymentLink = {
  'Choose another payment method': 'Elegir otra forma de pago',
  'Please wait': 'Espere…',
  Unavailable: 'No disponible',
  'This payment method does not meet the necessary criteria Please contact Vialaser for more information':
    'No fue posible concluir la contratación en esta forma de pago porque no cumple con los criterios necesarios. Comuníquese con Vialaser para más información.',
  'You have financial pendencies, so you cannot buy with this payment method':
    'Usted tiene pendientes financieros, por eso no puede realizar su compra en este método de pago',
  'This payment method is not available for this order':
    'Esta forma de pago no está disponible para este pedido',
  'Back to cart': 'Volver al carrito',
  'How do you want to pay?': '¿Cómo desea pagar?',
  'Choose a payment method to continue':
    'Elija una forma de pago para continuar',
  'No payment method is available for this order Please contact the clinic':
    'Ninguna forma de pago está disponible para este pedido. Comuníquese con la clínica',
  'Please confirm your document to continue your purchase':
    'Confirme su CI/DIMEX para continuar con su compra.',
  "Please confirm your guardian's document to continue your purchase":
    'Confirme el CI/DIMEX de su responsable legal para continuar con su compra.',
  'Confirm Document': 'Confirmar CI/DIMEX',
  'The document entered does not match the registration number, please contact the unit or try again':
    'El CI/DIMEX ingresado no coincide con el registro, comuníquese con la unidad o intente nuevamente',
  'Type the document here': 'Ingresa el CI/DIMEX aquí',
};
